import { render, staticRenderFns } from "./facet-detail-view.vue?vue&type=template&id=c4eed8d8&"
import script from "./facet-detail-view.ts?vue&type=script&lang=ts&"
export * from "./facet-detail-view.ts?vue&type=script&lang=ts&"
import style0 from "./facet-detail-view.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports